import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "@redux/hooks";
import { getTripletexIntegrationSettingsSelector, isSystemIntegratedSelector } from "@redux/features/auth/authSlice";
import { Alert } from "@mui/material";
import BaseIntegrationInject from "@reusables/BaseIntegrationInject";
import React from "react";

export default function TripletexWarning() {
    const { t } = useTranslation("", { keyPrefix: "sales.picking.tripletex" });

    const isTripletexIntegrated = useAppSelector(isSystemIntegratedSelector("tripletex"));
    const isTripletexInvoicingTurnedOn = useAppSelector((state) => getTripletexIntegrationSettingsSelector(state)?.auto_invoicing ?? false);

    if (!isTripletexIntegrated || isTripletexInvoicingTurnedOn) {
        return null;
    }

    return (
        <Alert severity="warning" className="mt-[16px]" icon={
            <BaseIntegrationInject integration={"tripletex"}>
                {
                    (integration, isLoading) =>
                        !isLoading ?
                            <img src={integration?.imageUrl} width={20} height={20}
                                 alt={integration?.name} /> : null
                }
            </BaseIntegrationInject>
        }>
            <Trans t={t} i18nKey="warnings.autoInvoicing.notEnabled" />
        </Alert>
    );
}
